import { FaBook, FaUsers, FaGraduationCap } from "react-icons/fa";

export const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;

export const campuses = [
  {
    id: "rajaji-nagar",
    name: "Rajajinagar Campus",
    tagline: "The Mothership — Established 1966",
    locationLabel: "Rajajinagar (Ramavana)",
    contacts: [
      {
        name: "Sri Vani Education Centre Trust (Head Office)",
        addressLines: [
          "Ramavana, #1246, 4th Main Road,",
          "‘E’ Block, 2nd Stage, Rajaji Nagar,",
          "Bengaluru 560010",
        ],
        phones: ["+91-80-2332 2239", "+91-80-2332 8801"],
        emails: ["rjnr@srivani.org"],
      },
    ],
    image: "/images/rajaji-nagar/campus-main.jpg",
    transport: true,
    curricula: ["CAIE (Cambridge)", "ICSE", "State Syllabus"],
    grades:
      "Cornerstone to A Level (CAIE) | Pre-Nursery to Class X (ICSE) | 8th–10th (State)",
    // students: "1500+",
    history:
      "It would be fair to call the Ramavana campus the mothership of the enterprise that is SVECT. With very humble beginnings Sri Vani which was till then functioning out of a rented duplex got its first break in 1974 when it was finally able to buy two adjoining sites that used to be a grazing field for cattle in 2nd stage Rajajinagar. The seeds that visionary Late Sri R S Hanumatha Rao had planted years ago was finally taking firm root. After that, there was no looking back. SVECT began to grow expansively. Ramavana now is a beloved landmark in the city.\n\n" +
      "Always abuzz with contagious energy, this campus offers a plethora of courses across boards. State syllabus packing decades of history and ICSE syllabus that consistently churns out results every year making it one of the best in the country. Ramavana recently went global with its affiliation to Cambridge and is already bringing accolades home putting the Sri Vani name on the World map!",
    highlights: [
      { icon: <FaBook />, title: "Library", count: "10,000+ books" },
      { icon: <FaUsers />, title: "Students", count: "1500+" },
      { icon: <FaGraduationCap />, title: "Faculty", count: "80+ teachers" },
    ],
    programs: [
      {
        name: "CAIE — Cambridge International",
        grades: "Nursery (Cornerstone) → Primary → IGCSE → A Level (Class 12)",
        description:
          "Internationally recognised curriculum from early childhood through A Level, covering Cambridge Primary, Lower Secondary, IGCSE, and AS & A Level.",
      },
      {
        name: "ICSE",
        grades: "Pre-Nursery to Class 10",
        description:
          "Indian Certificate of Secondary Education, offering a comprehensive and balanced course of study.",
      },
      {
        name: "State Syllabus (Karnataka)",
        grades: "Class 8 to Class 10",
        description:
          "Karnataka State Board curriculum with strong foundations in regional and national subjects.",
      },
    ],
    facilities: [
      {
        src: "/images/rajaji-nagar/tech-upgrade.jpg",
        label: "Technological Upgrade",
        desc: "We consistently provide a global standard of education that is affordable.",
      },
      {
        src: "/images/rajaji-nagar/vibrant-atmosphere.jpg",
        label: "Vibrant Atmosphere",
        desc: "Every parent wants their child to go far in life. Well, the very beginning is a great place to start!",
      },
      {
        src: "/images/rajaji-nagar/learn-play-grow.jpg",
        label: "Learn, Play, Grow!",
        desc: "This school isn't a destination, It is a path! Some of the best years of student life begin here.",
      },
      {
        src: "/images/rajaji-nagar/cornerstone.jpg",
        label: "Cornerstone of Life",
        desc: "A splendid experience for Kindergarten students with rooms styled like community spaces.",
      },
      {
        src: "/images/rajaji-nagar/assembly-ground.jpg",
        label: "Assembly Ground",
        desc: "Daily Prayers – Unwavering faith in our culture and our students thrive because of it.",
      },
      {
        src: "/images/rajaji-nagar/classrooms.jpg",
        label: "Modern Classrooms",
        desc: "Colourful desks to ergonomically designed chairs, we provide world class facilities.",
      },
      {
        src: "/images/rajaji-nagar/computer-lab.jpg",
        label: "Computer Lab",
        desc: "Love coding? Understand and control the device that rules the world in this day & age.",
      },
      {
        src: "/images/rajaji-nagar/biology-lab.jpg",
        label: "Biology Lab",
        desc: "A place of mystery and curiosity. Many doctors have found their calling in these labs.",
      },
      {
        src: "/images/rajaji-nagar/chemistry-lab.jpg",
        label: "Chemistry Lab",
        desc: "Colors! Sparks! Fumes! Odours! A room of magic where science happens!",
      },
      {
        src: "/images/rajaji-nagar/library.jpg",
        label: "Library",
        desc: "Sit down, read, stay where you are. Explore the world through books.",
      },
      {
        src: "/images/rajaji-nagar/auditorium.jpg",
        label: "Auditorium",
        desc: "Thousands have flourished in these halls – Join the family & gain a good education!",
      },
      {
        src: "/images/rajaji-nagar/examination-centre.jpg",
        label: "Examination Centre",
        desc: "Whatever the future may throw at us, Ramavana is ready. We adapt, revise, change & grow!",
      },
    ],
  },
  {
    id: "bashveshwarnagar",
    name: "Basaveshwaranagar Campus",
    tagline: "Shamavana — The Overachieving Middle Child",
    locationLabel: "Basaveshwaranagar (Shamavana)",
    contacts: [
      {
        name: "Sri Vani Education Centre",
        addressLines: [
          "Shamavana, CA- site No 1, 4th B Main,",
          "III Block, Basaveshwara Nagar,",
          "Bengaluru 560 079",
        ],
        phones: ["+91-80-2323 8608", "+91-80-2322 8078"],
        emails: ["bsnr@srivani.org"],
      },
    ],
    image: "/images/bashveshwarnagar/campus-main.jpg",
    curricula: ["ICSE"],
    grades: "Pre-Nursery to Class 10 (ICSE)",
    // students: "1200+",
    history:
      "Shamavana, like Ramavana, started off as a small structure with a sheet roof. It now stands tall bursting with energy. The overachieving middle child of the Sri Vani family, Shamavana maintains a perfect balance between academics and extracurricular activities. Its walls reflect the joyful aftermath of student activities — from Vani Kala Kendra programmes to vibrant Ramanavami and Navaratri celebrations.",
    highlights: [
      { icon: <FaBook />, title: "Knowledge Centre", count: "8,000+ books" },
      { icon: <FaUsers />, title: "Students", count: "1200+" },
      { icon: <FaGraduationCap />, title: "Faculty", count: "65+ teachers" },
    ],
    programs: [
      {
        name: "ICSE",
        grades: "Pre-Nursery to Class 10",
        description:
          "Indian Certificate of Secondary Education offering a comprehensive and balanced course of study.",
      },
    ],
    facilities: [
      {
        src: "/images/bashveshwarnagar/pillars-of-wisdom.jpg",
        label: "Pillars of Wisdom",
        desc: "Moving out of classrooms to a multi dimensional immersive learning experience.",
      },
      {
        src: "/images/bashveshwarnagar/colourful-environment.jpg",
        label: "Colourful Environment",
        desc: "Unlocking the infinite possibilities of your ward's intellect through a vibrant environment.",
      },
      {
        src: "/images/bashveshwarnagar/interactive-classrooms.jpg",
        label: "Interactive Classrooms",
        desc: "Teachers that change lives with just the right mix of chalk and challenges – Joyce Meyer.",
      },
      {
        src: "/images/bashveshwarnagar/math-lab.jpg",
        label: "Math Lab",
        desc: "Complex concepts & formulas made simple & fun in our interactive Math Lab.",
      },
      {
        src: "/images/bashveshwarnagar/biology-lab.jpg",
        label: "Biology Lab",
        desc: "Initiating young minds to learn and marvel at the fundamental knowledge of the living world.",
      },
      {
        src: "/images/bashveshwarnagar/chemistry-lab.jpg",
        label: "Chemistry Lab",
        desc: "Designed to study interactions between matter and energy in test tubes & flasks.",
      },
      {
        src: "/images/bashveshwarnagar/physics-lab.jpg",
        label: "Physics Lab",
        desc: "The inspiration to understand the universe, to seek answers about the laws that govern the world.",
      },
      {
        src: "/images/bashveshwarnagar/knowledge-centre.jpg",
        label: "Knowledge Centre",
        desc: "We are aware that an institution's personality can be understood with one look at its libraries.",
      },
      {
        src: "/images/bashveshwarnagar/computer-lab.jpg",
        label: "Computer Lab",
        desc: "A well-equipped station for our future programmers — computer science is important to almost every other industry.",
      },
      {
        src: "/images/bashveshwarnagar/play-and-bond.jpg",
        label: "Play & Bond",
        desc: "Nobody can take away or erase what the students learn here, the bonds forged, and the memories they make.",
      },
      {
        src: "/images/bashveshwarnagar/yoga-classes.jpg",
        label: "Yoga Classes",
        desc: "Yoga from a young age to untangle your child's body and mind. Relax, bend & stretch.",
      },
      {
        src: "/images/bashveshwarnagar/turn-and-swirl.jpg",
        label: "Turn & Swirl",
        desc: "Unique play sessions like Hula Hoop, which isn't just play, but also a way to skill up.",
      },
    ],
  },
  {
    id: "macholli",
    name: "Machohalli Campus",
    tagline: "A New Paradigm Of Education — 4.5 Acre Green Campus",
    locationLabel: "Machohalli (Hanumavana)",
    contacts: [
      {
        name: "Sri Vani Education Centre School",
        addressLines: [
          "Hanumavana, 16 KM off",
          "Magadi Road, Bapagram P.O,",
          "Machohalli, Bengaluru 560 091",
        ],
        phones: ["+91-80-2328 6998", "+91-80-2358 4870"],
        emails: ["mgdr@srivani.org"],
      },
      {
        name: "Sri Vani Vidya Kendra PU & Degree College",
        phones: ["+91-82969 70973", "+91-80-2977 0657"],
        emails: ["svvkpu@srivani.org", "svvkdegree@srivani.org"],
      },
    ],
    image: "/images/macholli/campus-main.jpg",
    transport: true,
    curricula: ["CBSE", "PU College", "Degree College"],
    grades: "Pre-Nursery to Class 12 (CBSE) | PUC & Degree",
    // students: "1800+",
    history:
      "The lush green Machohalli campus — a world tucked away from the dusty concrete jungle — is a homage to science and a botanist's paradise. Featuring diverse flora, geological specimens and educational exhibits, it represents a beautiful attempt by the visionary Late Sri R S Hanumatha Rao at making education more meaningful. Here, science learning happens outside traditional classrooms through hands-on exploration, not students restricted to a room glued to their books.",
    highlights: [
      { icon: <FaBook />, title: "Library", count: "15,000+ books" },
      { icon: <FaUsers />, title: "Students", count: "1800+" },
      { icon: <FaGraduationCap />, title: "Faculty", count: "95+ teachers" },
    ],
    programs: [
      {
        name: "CBSE — School",
        grades: "Pre-Nursery to Class 12",
        description:
          "Central Board of Secondary Education curriculum from early years through senior secondary.",
      },
      {
        name: "PU College",
        grades: "Class 11 & 12 (PUC)",
        description:
          "Science (PCMB, PCMC, CET/NEET/JEE) and Commerce (SEBA, CEBA, BASBm, CA Foundation) streams.",
      },
      {
        name: "Degree College",
        grades: "Undergraduate",
        description:
          "B.Com, BBA, BCA, B.Sc (PCM, PMCs) and BA (HEP, Dance, Drama, Music).",
      },
    ],
    facilities: [
      {
        src: "/images/macholli/science-outdoors.jpg",
        label: "Taking Science Outdoors",
        desc: "Jurassic Park? Nah. Sri Vani Science Park! Teleport to a pre-historic age.",
      },
      {
        src: "/images/macholli/rock-garden.jpg",
        label: "Rock Garden",
        desc: "Relics from millions of years ago. Ready for a geological adventure?",
      },
      {
        src: "/images/macholli/learning-centres.jpg",
        label: "Learning Centres",
        desc: "The best environment during formative years; after all from small beginnings come great things.",
      },
      {
        src: "/images/macholli/art-attack.jpg",
        label: "The Art Attack",
        desc: "Every child is an artist, the challenge is remaining one as you grow up!",
      },
      {
        src: "/images/macholli/pu-degree-college.jpg",
        label: "PU & Degree College",
        desc: "Your launchpad to the top through dynamic and spirited higher education.",
      },
      {
        src: "/images/macholli/transport.jpg",
        label: "Transport Facility",
        desc: "Safe and secure at your doorstep with GPS tracking & CCTV surveillance.",
      },
      {
        src: "/images/macholli/classroom-college.jpg",
        label: "Classroom — College",
        desc: "Walk into a room full of vibrant individuals, and a whole new world of possibilities.",
      },
      {
        src: "/images/macholli/computer-lab-college.jpg",
        label: "Computer Lab — College",
        desc: "We at SVECT understand & provide only the best in technology for our tech-savvy students.",
      },
      {
        src: "/images/macholli/chemistry-lab-college.jpg",
        label: "Chemistry Lab — College",
        desc: "Equipped with all the apparatus you need to explore, experiment and discover.",
      },
      {
        src: "/images/macholli/physics-lab-college.jpg",
        label: "Physics Lab — College",
        desc: "Time and space are not conditions in which we live, but modes by which we think.",
      },
      {
        src: "/images/macholli/biology-lab-college.jpg",
        label: "Biology Lab — College",
        desc: "Designed for the inquisitive minds that want to study life under a microscope.",
      },
      {
        src: "/images/macholli/playground.jpg",
        label: "Spacious Playground",
        desc: "Run! Jump! Play! In a place where important lessons that cannot be taught in the classroom are learnt.",
      },
      {
        src: "/images/macholli/brain-gym.jpg",
        label: "A Brain Gym",
        desc: "The mind needs regular work out too. A choice selection of indoor games caters to exactly that.",
      },
      {
        src: "/images/macholli/observatory.jpg",
        label: "Celestial Observatory",
        desc: "Future astronomers understand that sometimes, one has to look up to find answers within.",
      },
      {
        src: "/images/macholli/library.jpg",
        label: "Library — Knowledge Centre",
        desc: "So many books so little time! Inculcating a love for reading & a thirst for knowledge.",
      },
      {
        src: "/images/macholli/math-lab.jpg",
        label: "Number Nagar — Math Lab",
        desc: "Mathematics is neither scary nor difficult, we have a lab to prove that it can be quite fun!",
      },
      {
        src: "/images/macholli/chemistry-lab-school.jpg",
        label: "Chemistry Lab — School",
        desc: "Actions, Reactions and Experiments! Don't forget to balance your Equations!",
      },
      {
        src: "/images/macholli/biology-lab-school.jpg",
        label: "Biology Lab — School",
        desc: "Only the best, as without labs our young scientists would be like soldiers without ammunition!",
      },
      {
        src: "/images/macholli/physics-lab-school.jpg",
        label: "Physics Lab — School",
        desc: "A place where inspiration meets discovery. The study of matter the way it matters!",
      },
      {
        src: "/images/macholli/computer-lab-school.jpg",
        label: "Computer Lab — School",
        desc: "A hub built to boost our future coders, programmers and developers.",
      },
    ],
  },
  {
    id: "naavruja",
    name: "Nagavruja Campus",
    tagline: "Sri Vani School — Pavanje",
    contacts: [
      {
        addressLines: ["Sri Vani School, Nagavruja,", "Pavanje"],
        phones: ["+91 80 233 222 39"],
        emails: ["ask@srivani.org"],
      },
    ],
    image: "/images/naavruja/campus-main.jpg",
    curricula: ["State Syllabus", "CBSE", "PU College"],
    grades: "Pre-KG to Class 10 (State) | Pre-KG to Class 12 (CBSE) | PUC",
    students: "1000+",
    history: "Sri Vani School, Nagavruja, a unit of SVECT, is all set to sparkle the deep-rooted legacy of SVECT in the divine and serene land of Pavanje. Sri Vani School offers State Syllabus and CBSE catering to students from Pre-KG to Class 10 and beyond. The school takes utmost care to guarantee academic excellence and co-curricular expertise in students. With a team of well-qualified, curated, and devoted staff, Sri Vani School is well equipped to nurture and transform young minds.",
    highlights: [
      { icon: <FaBook />, title: "Library", count: "12,000+ books" },
      { icon: <FaUsers />, title: "Students", count: "1000+" },
      { icon: <FaGraduationCap />, title: "Faculty", count: "70+ teachers" },
    ],
    programs: [
      {
        name: "State Syllabus (Karnataka)",
        grades: "Pre-KG to Class 10",
        description: "Karnataka State Board curriculum nurturing young minds with strong academic and co-curricular foundations.",
      },
      {
        name: "CBSE",
        grades: "Pre-KG to Class 12",
        description: "Central Board of Secondary Education offering a nationally recognised curriculum from early years through senior secondary.",
      },
      {
        name: "PU College",
        grades: "Class 11 & 12 (PUC)",
        description: "Science (PCMB, PCMC) and Commerce (SEBA, CEBA, BASBm) streams along with CA Foundation.",
      },
    ],
    facilities: [
      { src: "/images/naavruja/yoga.jpg", label: "Yoga", desc: "Yoga — a union of the body, mind, soul, and universal consciousness." },
      { src: "/images/naavruja/classroom.jpg", label: "Classroom", desc: "Walk into a room full of vibrant individuals, and a whole new world of possibilities." },
      { src: "/images/naavruja/computer-lab.jpg", label: "Computer Lab", desc: "We at SVECT understand & provide only the best in technology for our tech-savvy students." },
      { src: "/images/naavruja/playground.jpg", label: "Spacious Playground", desc: "Run! Jump! Play! In a place where important lessons that cannot be taught in the classroom are learnt." },
      { src: "/images/naavruja/library.jpg", label: "Library — Knowledge Centre", desc: "So many books so little time! Inculcating a love for reading & a thirst for knowledge." },
      { src: "/images/naavruja/science-park.jpg", label: "Science Park", desc: "Jurassic Park? Nah. Sri Vani Science Park! Teleport to a pre-historic age." },
      { src: "/images/naavruja/rock-garden.jpg", label: "Rock Garden", desc: "Relics from millions of years ago. Ready for a geological adventure?" },
      { src: "/images/naavruja/learning-centres.jpg", label: "Learning Centres", desc: "The best environment during formative years; after all from small beginnings come great things." },
      { src: "/images/naavruja/art-attack.jpg", label: "The Art Attack", desc: "Every child is an artist, the challenge is remaining one as you grow up! – Picasso." },
      { src: "/images/naavruja/pu-degree-college.jpg", label: "PU & Degree College", desc: "Your launchpad to the top through dynamic and spirited higher education." },
    ],
  },
];
